/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * This entity collects the Client's protection permission marks gathered for different channels
 */
export interface DataProtection {
  /**
   * Identificator of the data protection type
   */
  dataProtectionId?: string;
  /**
   * Indicates the type of approval provided by the Customer, for example: 01 - Advertising, 02 - Electronic business communications, 03 - Data transfer, 04 - Customer analytics, 05 - Profiling, 06 - Data Transfer, 07 - Internationality
   */
  approvalTypeCode?: string;
  /**
   * Description of the approval provided by the Customer
   */
  readonly approvalTypeDesc?: string;
  /**
   * Data protection granted form code, for example: 01 - Not awarded, 02 - Tacit, 03 - Express, 04 - Retired
   */
  grantedFormCode?: string;
  /**
   * Description of the Data protection granted
   */
  readonly grantedFormDesc?: string;
  /**
   * Indicates the channel wich has been subject of approval by the Client
   */
  channel?: string;
  /**
   * Description of the data protection type
   */
  formDesc?: string;
  /**
   * Start date of the data protection consent
   */
  startDateDP?: Date;
  /**
   * End date of the data protection consent
   */
  endDateDP?: Date;
}
